import { CircularProgress, FormControl, MenuItem, Select } from "@mui/material"
import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import {
  getNotificationConditionType,
  setRequestNotificationConditionTypes,
} from "../../../../redux/actions/eAuthz"

export const SelectNotificationConditions = ({
  notificationCondSelect,
  handleChange,
}) => {
  const [loading, setloading] = useState(false)

  const { notificationConditionTypes } = useSelector(
    (state) => state.globalNotification,
  )
  const dispatch = useDispatch()

  const loadNotificationConditions = async () => {
    setloading(true)
    await dispatch(getNotificationConditionType())
    setloading(false)
  }

  useEffect(() => {
    loadNotificationConditions()
    return () => {
      dispatch(setRequestNotificationConditionTypes())
    }
  }, [])

  if (loading)
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          color: "#00a78f",
          width: 200,
        }}
      >
        <CircularProgress color="inherit" />
      </div>
    )
  return (
    <div style={{ width: "100%" }}>
      <FormControl variant="standard" sx={{ m: 1, minWidth: 200 }}>
        <Select
          labelId="demo-simple-select-standard-label"
          id="demo-simple-select-standard"
          value={notificationCondSelect}
          onChange={handleChange}
          label="Exclusiones"
        >
          <MenuItem value={""}></MenuItem>
          {notificationConditionTypes &&
            notificationConditionTypes.map((i) => (
              <MenuItem
                key={i.notification_condition_type_id}
                value={i.notification_condition_type_id}
              >
                {i.notification_condition_type_desc}
              </MenuItem>
            ))}
        </Select>
      </FormControl>
    </div>
  )
}
